import axios from 'axios'

const API_URL = ' https://cloudapi.lykdat.com/v1'
const BG_API_URL = API_URL
const DEEP_TAG_API_URL = 'https://cloudapi.lykdat.com/v1/detection/tags'
const API_KEY = '207f5b46ff05254fd82900e5d4cde46456a10234851cc5875b36ea49f3a46c39'

interface DetectedItem {
    name: string
    category: string | null
    detection_confidence: number
}

export interface DetectItemsResponse {
    detected_items: DetectedItem[]
}

export async function detectItems(img: Blob): Promise<DetectItemsResponse> {
    const formData = new FormData()
    formData.append('image', img, 'image.jpeg')

    const url = `${API_URL}/detection/items`
    const headers = {'x-api-key': API_KEY}
    const resp = await axios.post(url, formData, { headers })

    return resp.data.data
}

interface DetectedColor {
    name: string
    confidence: number
    hex_code?: string
}

export interface ImageTranscodeResponse {
    image: string
}

export async function removeImageBackground(img: Blob): Promise<ImageTranscodeResponse> {
    const formData = new FormData()
    formData.append('image', img, 'image.jpeg')

    const headers = {'x-api-key': API_KEY}
    const url = `${BG_API_URL}/images/transcode`
    const resp = await axios.post(url, formData, { headers })

    return resp.data.data
}

export interface ImageTaggingResponse {
    colors: DetectedColor[]
    labels: {
        classification: string
        name: string
        confidence: number
        secondary_classification: number | null
    }[]
    description?: string
}

export async function getTagging(img: Blob, apiUrl = DEEP_TAG_API_URL): Promise<ImageTaggingResponse> {
    const formData = new FormData()
    formData.append('image', img, 'image.jpeg')

    const headers = {'x-api-key': API_KEY}
    const resp = await axios.post(apiUrl, formData, { headers })

    return resp.data.data
}
